export default {
    'Mega Menu': 'Mega Menu',
    Search: 'Ricerca',
    Menu: 'Menù',
    Dashboard: 'Pannello di controllo',
    Calendar: 'Calendario',
    Chat: 'Chiacchierare',
    Ecommerce: 'ecommerce',
    Products: 'Prodotti',
    'Product Detail': 'Dettagli del prodotto',
    Customers: 'I clienti',
    Cart: 'Carrello',
    Checkout: 'Check-out',
    Shops: 'negozi',
    'Add Product': 'Aggiungi prodotto',
    Email: 'E-mail',
    Inbox: 'Posta in arrivo',
    'Read Email': "Leggi l'email",
    'Kanban Board': 'Kanban Board',
    Layouts: 'layout',
    Horizontal: 'Orizzontale',
    'Dark Sidebar': 'Barra laterale scura',
    'Default Sidebar': 'Barra laterale predefinita',
    'Compact Sidebar': 'Barra laterale compatta',
    'Icon Sidebar': 'Icona Sidebar',
    'Boxed Layout': 'Layout in scatola',
    'Fluid Layout': 'Layout fluido',
    Preloader: 'preloader',
    'Without Preloader': 'Senza Preloader',
    Pages: 'pagine',
    Authentication: 'Autenticazione',
    Login: 'Accesso',
    Register: 'Registrati',
    'Recover Password': 'Recupera la password',
    'Lock Screen': 'Blocca schermo',
    Utility: 'Utilità',
    'Starter Page': 'Pagina iniziale',
    Maintenance: 'Manutenzione',
    'Coming Soon': 'Prossimamente',
    Timeline: 'Sequenza temporale',
    FAQs: 'FAQs',
    Pricing: 'Prezzi',
    'Error 404': 'Errore 404',
    'Error 500': 'Errore 500',
    Components: 'componenti',
    'UI Elements': "Elementi dell'interfaccia utente",
    Alerts: 'avvisi',
    Buttons: 'pulsanti',
    Cards: 'Carte',
    Carousel: 'Giostra',
    Dropdowns: 'menu a discesa',
    Grid: 'Griglia',
    Images: 'immagini',
    Lightbox: 'ID',
    Modals: 'Modals',
    'Range Slider': 'Cursore gamma',
    'Round Slider': 'Cursore tondo',
    'Session Timeout': 'Timeout della sessione',
    'Progress Bars': 'Indicatori di stato',
    'Sweet-Alert': 'Sweet-Alert',
    'Tabs & Accordions': 'Schede e fisarmoniche',
    Typography: 'Tipografia',
    Video: 'Video',
    General: 'Generale',
    Rating: 'Valutazione',
    Notifications: 'notifiche',
    Forms: 'Le forme',
    Elements: 'Elementi',
    Validation: 'Validazione',
    'Advanced Plugins': 'Plugin avanzati',
    Editors: 'Editors',
    'File Upload': 'Upload di file',
    'X-editable': 'X-modificabile',
    Wizard: 'procedura guidata',
    Mask: 'Maschera',
    Tables: 'tabelle',
    'Basic Tables': 'Tabelle di base',
    'Data Tables': 'Tabelle dati',
    'Responsive Table': 'Tabella reattiva',
    'Editable Table': 'Tabella modificabile',
    Charts: 'Grafici',
    Apexcharts: 'Apexcharts',
    Chartist: 'Cartista',
    Chartj: 'Chartj',
    'Jquery Knob': 'Manopola Jquery',
    Sparkline: 'Sparkline',
    Icons: 'Icone',
    'Remix Icons': 'Icone di Remix',
    'Material Design': 'Design materiale',
    Dripicons: 'Dripicons',
    'Font awesome 5': 'Carattere fantastico 5',
    Maps: 'Mappe',
    'Google Maps': 'Google Maps',
    'Vector Maps': 'Mappe vettoriali',
    'Multi Level': 'Multi livello',
    'Level 1.1': 'Livello 1.1',
    'Level 1.2': 'Livello 1.2',
    'Level 2.1': 'Livello 2.1',
    'Level 2.2': 'Livello 2.2',
    Profile: 'Profilo',
    'My Wallet': 'Il mio portafoglio',
    Settings: 'impostazioni',
    'View more': 'Vedi di più',
    'View all': 'Mostra tutto',
    Logout: 'Disconnettersi',
    'Your order is placed': 'Il tuo ordine è stato effettuato',
    'If several languages coalesce the grammar': 'Se diverse lingue fondono la grammatica',
    'Your item is shipped': 'Il tuo articolo viene spedito',
    '3 min ago': '3 min fa',
    'James Lemire': 'James Lemire',
    'It will seem like simplified English.': 'Sembrerà un inglese semplificato.',
    '1 hours ago': '1 ora fa',
    'Salena Layfield': 'Salena Layfield',
    'As a skeptical Cambridge friend of mine occidental.': 'Come un mio scettico amico di Cambridge occidentale.',
    'View More..': 'Visualizza altro ..',
    'UI Components': "Componenti dell'interfaccia utente",
    Applications: 'applicazioni',
    'Extra Pages': 'Pagine extra',
    Github: 'Github',
    Bitbucket: 'bitbucket',
    Dribble: 'Dribblare',
    Dropbox: 'Dropbox',
    'Mail Chimp': 'Mail Chimp',
    Slack: 'allentato'
};
